// Shared option maps, labels, and array paths for the 2026 all-claims-v2 526 form.
// Kept centralized so the schema module and page uiSchemas stay in sync and this
// set can move to vets-json-schema later alongside the schema.

// Form title (h1). Matches the live 526 (all-claims) PAGE_TITLES copy.
export const PAGE_TITLES = {
  ALL: 'File for disability compensation',
  BDD: 'File a Benefits Delivery at Discharge claim',
};

export const PAGE_TITLE_SUFFIX = 'with VA Form 21-526EZ';

// Section V, Item 10A — Branch of service
export const SERVICE_BRANCH_LABELS = {
  army: 'Army',
  airForce: 'Air Force',
  navy: 'Navy',
  marineCorps: 'Marine Corps',
  coastGuard: 'Coast Guard',
  spaceForce: 'Space Force',
  noaa: 'NOAA',
  usphs: 'USPHS',
};

// Section V, Item 10B / 12B — Component
export const SERVICE_COMPONENT_LABELS = {
  active: 'Active service',
  reserves: 'Reserves',
  nationalGuard: 'National Guard',
};

export const RESERVE_COMPONENT_LABELS = {
  RESERVES: 'Reserves',
  NATIONAL_GUARD: 'National Guard',
};

// Section V, Item 13 — POW era / campaign
export const POW_ERA_LABELS = {
  wwii: 'World War II',
  korea: 'Korea',
  vietnam: 'Vietnam',
  gulfWarIraq: 'Gulf War or Iraq',
  oif: 'Operation Iraqi Freedom (OIF)',
  oef: 'Operation Enduring Freedom (OEF)',
};
export const POW_ERA_KEYS = Object.keys(POW_ERA_LABELS);

// Private medical records — type of provider.
export const PROVIDER_TYPE_LABELS = {
  privateProvider: 'Private healthcare provider',
  vetCenter: 'Vet Center',
  communityCare: 'Community care (paid for by VA)',
  notSure: 'I’m not sure',
  other: 'Other',
};
export const PROVIDER_TYPE_KEYS = Object.keys(PROVIDER_TYPE_LABELS);

// VA medical records — facility type
export const VA_FACILITY_TYPE_LABELS = {
  vaMedicalCenter: 'VA medical center or clinic',
  cboc: 'Community-Based Outpatient Clinic',
  dodMtf: 'DOD military treatment facility',
  notSure: 'I’m not sure',
  other: 'Other',
};
export const VA_FACILITY_TYPE_KEYS = Object.keys(VA_FACILITY_TYPE_LABELS);

// Treatment facility address. A military state code (AA/AE/AP) must be paired
// with a military city code (APO/DPO/FPO), and vice versa.
export const USA = 'USA';
export const MILITARY_STATE_VALUES = ['AA', 'AE', 'AP'];
export const MILITARY_CITIES = ['APO', 'DPO', 'FPO'];

// Array-builder paths
export const VA_FACILITIES_ARRAY_PATH = 'vaTreatmentFacilities';
export const PROVIDER_FACILITIES_ARRAY_PATH = 'providerFacility';

export const CHECKBOXGROUP_HINT_TEXT = 'Select all that apply.';

export const SERVICE_PAY_TYPE_LABELS = {
  militaryRetiredPay: 'Retired pay',
  trainingPay: 'Active or inactive duty training pay',
};

export const SERVICE_PAY_TYPE_KEYS = Object.keys(SERVICE_PAY_TYPE_LABELS);
